<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="right-info">
      Утвержден Приказом Председателя<br />
      Агентства Республики Казахстан<br />
      по делам строительства и<br />
      жилищно-коммунального хозяйства<br />
      от 29 декабря 2011 года № 536<br />
      <br />
      Сборник нормативно-технической<br />
      и исполнительной документации,<br />
      необходимой при проведении<br />
      строительно-монтажных работ<br />
      (паспорт строительства)<br />
      <br />
      Приложение 15
    </div>
    <div class="chapter-title">ЖУРНАЛ ПОДВОДНОГО БЕТОНИРОВАНИЯ</div>
    <n-items v-if="project">
      <n-input title="Строительная организация" v-bind="$form.input('executor')" />
      <n-input title="Строительство" v-bind="$form.input('building')" />
      <n-input title="Журнал начат" v-bind="$form.input('startedAt')" />
      <n-input title="Журнал окончен" v-bind="$form.input('endedAt')" />
    </n-items>

    <div class="chapter-title">
      ЖУРНАЛ<br />
      ПОДВОДНОГО БЕТОНИРОВАНИЯ СКВАЖИНЫ, УШИРЕНИИ ОБОЛОЧЕК, ОПУСКНЫХ КОЛОДЦЕВ И КОТЛОВАНОВ ФУНДАМЕНТОВ
    </div>

    <n-items>
      <n-input title="Опора №." v-bind="$form.input('supportNumber')" inline />
      <div style="width: 100%">Задание характеристики бетона</div>
    </n-items>

    <table class="simple-table">
      <tr>
        <td rowspan="2">Показатели</td>
        <td rowspan="2">Ед. изм.</td>
        <td colspan="3">Тип бетонируемой конструкции</td>
      </tr>
      <tr>
        <td>оболочка, скважина, уширение</td>
        <td>опускной колодец</td>
        <td>котлован фундамента</td>
      </tr>
      <tr>
        <td>1</td>
        <td>2</td>
        <td>3</td>
        <td>4</td>
        <td>5</td>
      </tr>
      <tr>
        <td class="left">Класс бетона</td>
        <td></td>
        <td><n-input inline v-bind="$form.input('class3')" /></td>
        <td><n-input inline v-bind="$form.input('class4')" /></td>
        <td><n-input inline v-bind="$form.input('class5')" /></td>
      </tr>
      <tr>
        <td class="left">Водоцементное отношение</td>
        <td></td>
        <td><n-input inline v-bind="$form.input('water3')" /></td>
        <td><n-input inline v-bind="$form.input('water4')" /></td>
        <td><n-input inline v-bind="$form.input('water5')" /></td>
      </tr>
      <tr>
        <td class="left">Расход цемента</td>
        <td>кг/см<sup>3</sup></td>
        <td><n-input inline v-bind="$form.input('consumption3')" /></td>
        <td><n-input inline v-bind="$form.input('consumption4')" /></td>
        <td><n-input inline v-bind="$form.input('consumption5')" /></td>
      </tr>
      <tr>
        <td class="left">Подвижность смеси (осадка конуса)</td>
        <td>см</td>
        <td><n-input inline v-bind="$form.input('mobility3')" /></td>
        <td><n-input inline v-bind="$form.input('mobility4')" /></td>
        <td><n-input inline v-bind="$form.input('mobility5')" /></td>
      </tr>
      <tr>
        <td class="left">Относительное водоотделение</td>
        <td>%</td>
        <td><n-input inline v-bind="$form.input('waterSeppar3')" /></td>
        <td><n-input inline v-bind="$form.input('waterSeppar4')" /></td>
        <td><n-input inline v-bind="$form.input('waterSeppar5')" /></td>
      </tr>
      <tr>
        <td class="left">№ карточки подбора состава бетона</td>
        <td></td>
        <td><n-input inline v-bind="$form.input('compound3')" /></td>
        <td><n-input inline v-bind="$form.input('compound4')" /></td>
        <td><n-input inline v-bind="$form.input('compound5')" /></td>
      </tr>
    </table>
    <br />
    <br />
    <n-items>
      <n-input title="Ответственный за производство работ и ведение журнала" v-bind="$form.input('responsibleWork')" :text="!editable" />
      <div style="width: 100%">Примечание. К журналу прилагается схема размещения бетонолитных труб и контрольных точек.</div>
      <n-input title="Характеристика объекта бетонирования" v-bind="$form.input('charObjConcrete')" :text="!editable" />
      <n-input title="Начало бетонирования" v-bind="$form.input('concretedStartedAt')" :text="!editable" />
      <n-input title="Конец бетонирования" v-bind="$form.input('concretedEndedAt')" :text="!editable" />
    </n-items>
    <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
    .simple-table {
      td {
        text-align: center;
        padding: 3px 7px;
        border: 1px solid var(--border-color);
      }
      .left {
        text-align: left;
      }
    }
  }
</style>
